import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { Auth } from 'aws-amplify'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  async config => {
    // do something before request is sent
    const user = Auth.currentAuthenticatedUser()
    const token = await Auth.currentSession(user).then(user => {
      Promise.resolve()
      return user.getIdToken().jwtToken
    }).catch(error => {
      Promise.reject(error)
    })
    if (token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    if (response.status === 200) {
      return response.data
    } else {
      return Promise.reject(new Error(res.message || 'Error'))
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 20 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
